import React from 'react';

const InformacionPago = ({ formData, handleChange, nombreArchivo }) => {
  return (
    <div className="informacion-pago">
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center'
      }}>
        <span style={{
          backgroundColor: '#ddd6fe',
          color: '#7c3aed',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '0.75rem',
          fontWeight: 'bold',
          fontSize: '0.875rem'
        }}>4</span>
        Información de Pago
      </h2>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '2rem',
        alignItems: 'start'
      }}>
        {/* Información de pago */}
        <div style={{
          backgroundColor: '#f0f9ff',
          border: '1px solid #bfdbfe',
          borderRadius: '8px',
          padding: '1rem'
        }}>
          <p style={{
            fontSize: '1rem',
            color: '#3A7D5C',
            marginBottom: '0.75rem',
            fontWeight: '500',
            textAlign: 'left'
          }}>
            Valor: $40.000 COP por persona hasta el 15 de abril.
          </p>
          <p style={{
            fontSize: '1rem',
            color: '#3A7D5C',
            marginBottom: '0.75rem',
            fontWeight: '500',
            textAlign: 'left'
          }}>
            Desde el 16 de abril al 15 mayo de 2026, el costo será de $50.000 COP por persona.
          </p>
          <p style={{
            fontSize: '1rem',
            color: '#3A7D5C',
            marginBottom: '0.75rem',
            fontWeight: '500',
            textAlign: 'left'
          }}>
            Menores de edad no pagan.
          </p>
          <p style={{
            fontSize: '1rem',
            color: '#3A7D5C',
            marginBottom: '0.75rem',
            fontWeight: '500',
            textAlign: 'left'
          }}>
           Cuenta de ahorros bancolombia #21800000305 a nombre de Iglesia Cristiana Cuadrangular con NIT 890200937-3.
          </p>
          <p style={{
            fontSize: '1rem',
            color: '#3A7D5C',
            marginBottom: '0',
            fontWeight: '500',
            textAlign: 'left'
          }}>
           Enviar el comprobante de pago al numero de WhatsApp{' '}
            <span style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              marginRight: '4px',
              width: '16px',
              height: '16px',
              verticalAlign: 'middle'
            }}>
              <svg viewBox="0 0 24 24" fill="#25D366">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.039 1.014-1.039 2.475 1.065 2.862 1.213 3.059c.149.197 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.084 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.123-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.885-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
            </span>
            313-805-6230.
          </p>
        </div>
        
        {formData.metodoPago !== 'efectivo' && (
          <div>
            {/* Comprobante de Pago */}
            <div style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
              <label>Comprobante de Pago</label>
            </div>
            <div style={{ position: 'relative' }}>
              <input
                type="file"
                name="comprobantePago"
                onChange={handleChange}
                accept="image/*,.pdf"
                style={{
                  position: 'absolute',
                  opacity: 0,
                  width: '100%',
                  height: '100%',
                  cursor: 'pointer'
                }}
                id="comprobantePago"
              />
              <label
                htmlFor="comprobantePago"
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '0.75rem 1rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.5rem',
                  fontSize: '1rem',
                  backgroundColor: nombreArchivo ? 'transparent' : 'white',
                  background: nombreArchivo ? 'linear-gradient(135deg, #3A7D5C 0%, #16a34a 50%, #2C5530 100%)' : 'none',
                  color: nombreArchivo ? 'white' : '#374151',
                  cursor: 'pointer',
                  textAlign: 'center',
                  transition: 'all 0.2s',
                  boxSizing: 'border-box'
                }}
                onMouseOver={(e) => {
                  if (!nombreArchivo) {
                    e.target.style.backgroundColor = '#f9fafb';
                    e.target.style.borderColor = '#9ca3af';
                  }
                }}
                onMouseOut={(e) => {
                  if (!nombreArchivo) {
                    e.target.style.backgroundColor = 'white';
                    e.target.style.borderColor = '#d1d5db';
                  }
                }}
              >
                {nombreArchivo || 'Seleccionar archivo (PDF o imagen)'}
              </label>
            </div>
          </div>
        )}
        
        {/* Formulario de pago */}
        <div style={{
          backgroundColor: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '1rem'
        }}>
          {/* Métodos de Pago */}
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
              Método de pago
            </label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label className="radio-label">
                <input
                  type="radio"
                  name="metodoPago"
                  value="archivo"
                  checked={formData.metodoPago === 'archivo' || !formData.metodoPago}
                  onChange={handleChange}
                  className="radio-input"
                />
                Pago con comprobante (archivo)
              </label>
              
              {(formData.comprobantePago && 
                typeof formData.comprobantePago === 'string' && 
                formData.comprobantePago !== '' && 
                formData.comprobantePago !== 'No adjuntado' && 
                formData.comprobantePago !== 'Efectivo') ? null : (
                <label className="radio-label">
                  <input
                    type="radio"
                    name="metodoPago"
                    value="efectivo"
                    checked={formData.metodoPago === 'efectivo'}
                    onChange={handleChange}
                    className="radio-input"
                  />
                  Pago en efectivo
                </label>
              )}
            </div>
          </div>
          
          {/* Mostrar comprobante existente si hay */}
          {formData.comprobantePago && 
           typeof formData.comprobantePago === 'string' && 
           formData.comprobantePago !== '' && 
           formData.comprobantePago !== 'No adjuntado' && 
           formData.metodoPago !== 'efectivo' && (
            <div style={{
              padding: '1rem',
              backgroundColor: '#f0fdf4',
              border: '1px solid #bbf7d0',
              borderRadius: '0.5rem'
            }}>
              <p style={{
                margin: '0 0 0.5rem 0',
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#166534',
                textAlign: 'center'
              }}>
                ✅ Puedes actualizarlo seleccionando un nuevo archivo arriba
              </p>
              
              {/* Vista previa si es imagen */}
              {formData.comprobantePago.startsWith('data:image/') && (
                <div style={{
                  marginTop: '0.75rem',
                  maxWidth: '200px',
                  maxHeight: '150px',
                  overflow: 'hidden',
                  borderRadius: '0.375rem',
                  border: '1px solid #86efac'
                }}>
                  <img 
                    src={formData.comprobantePago} 
                    alt="Comprobante existente" 
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              )}
              
              {/* Indicador si es PDF */}
              {formData.comprobantePago.startsWith('data:application/pdf') && (
                <div style={{
                  marginTop: '0.75rem',
                  padding: '0.5rem',
                  backgroundColor: '#dcfce7',
                  borderRadius: '0.25rem',
                  fontSize: '0.75rem',
                  color: '#15803d'
                }}>
                  📄 Comprobante en formato PDF
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InformacionPago;
